<template>
    <div>
        <app-form v-bind:parentObject="{
            data: this.formData,
            pageTitle: this.pageTitle,
            isEdit: this.isEdit,
        }" v-on:input="formData = $event" v-on:save="saveHandler" v-on:error="errorHandler" />
        <div v-if="isErr">
            <app-error v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }" v-on:closeError="isErr = $event" />
        </div>
    </div>
</template>

<script>
import acknowledgementForm from "../../../components/settings/acknowledgement/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": acknowledgementForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            pageTitle: this.$t('acknowledgement.newacknowledgement'),
            formData: {
                id: null,
                ackTypeId: null,
                ackName: null,
                ackLongDesc: null,
                createDate: null,
                publishDate: null,
                suspendStatus: 0,//default false
                content: null,
                remark: null,
                detailItemList: [],
                attach: null,
                attachname: null,
                stamp: 0,
                updatedby: this.$store.getters.userId,
            },

            errMsg: "",
            isErr: false,
            isEdit: false,
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        saveHandler() {
            const vm = this;
            if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                console.error("cannot add");
                vm.isErr = true;
                vm.errMsg = "No permission to add record";
                return false;
            }
            // console.log("form data to be saved in New", this.formData);
            this.$store.dispatch('post', { url: "/acknowledgement/new", payload: vm.formData })
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;

                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        // console.log("Newly inserted acknowledgement record", res.data.newInsertedId);
                        this.$router.push({ name: "acknowledgementgrid" });
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
        },
    },
};
</script>